import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthlyExpenseByMonthDatatable";

import {
  getSingleMonthlyRedux,
  clearSingleMonthRedux,
} from "../../../actions/index";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import "./lot-transport.css";

export class MonthlyExpenseByMonth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
    };
  }

  componentDidMount = async () => {
    this.props.getSingleMonthlyRedux(
      this.props.match.params.month,
      "TRANSPORT"
    );
  };
  componentWillUnmount = () => {
    this.props.clearSingleMonthRedux();
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };

  render() {
    const { open } = this.state;
    const allExpenses = this.props.allExpenses || [];
    let total = 0;
    allExpenses.forEach((expense) => {
      total += parseInt(expense.amount) || 0;
    });

    console.log(this.props);
    return (
      <Fragment>
        <Breadcrumb title="Transport" parent="Cash in/out" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid lt-page kd-cash kd-st--sky">
          <div className="row">
            <div className="col-sm-12">
              <div className="card lt-card">
                <div className="card-header lt-card-header">
                  <h5 className="lt-card-title">
                    <i className="icofont-calendar lt-card-icon"></i>
                    {this.props.match.params.month}
                  </h5>
                </div>
                <div className="card-body">
                  <div className="lt-total-chip">
                    <span className="lt-total-chip-label lt-stamp-font">Month Total</span>
                    <span className="lt-total-chip-value">{total}Tk</span>
                  </div>
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      history={this.props.history}
                      multiSelectOption={false}
                      myData={this.props.allExpenses}
                      pageSize={50}
                      pagination={true}
                      class="-striped -highlight"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allExpenses: state.expenses.singleMonth,
  };
};

export default connect(mapStateToProps, {
  getSingleMonthlyRedux,
  clearSingleMonthRedux,
})(MonthlyExpenseByMonth);
